module.exports = __webpack_public_path__ + "static/media/143.c7476a02.png";